














import LoginForm from './LoginForm.vue';
import { defineComponent } from '@vue/composition-api';

const Component = defineComponent({
  name: 'LoginPage',

  components: {
    LoginForm,
  },
});

export default Component;
